import { useContext } from 'react'

import { WorkdayJobsContext } from '../WorkdayJobsContext'

export default function Activefilters() {
  const { filteredJobscount, filters, resetFilters, removeFilter } = useContext(WorkdayJobsContext)

  const showFilters = filters && Object.values(filters).some(arr => arr?.length > 0)
  return (
    <div className="cmp-filterbar__active-filters">
      <p className="cmp-filterbar__count">{`${filteredJobscount} items${showFilters ? ' filtered by' : ''}`}</p>
      {filters && showFilters && (
        <div className="cmp-filterbar__tags">
          {Object.entries(filters).map(([category, items]) =>
            items.map((item, index) => (
              <button
                key={`${category}-${index}`}
                className="cmp-filterbar__button cmp-filterbar__button--tag"
                aria-label={`Remove filter for: ${item}`}
                onClick={() => removeFilter(category, item)}
              >
                <span className="cmp-filterbar__button-text">{item}</span>
                <span className="icon--sm icon-close icon-placement--after-label"></span>
              </button>
            )),
          )}
          <button className="cmp-filterbar__button cmp-filterbar__button--clear-all" aria-label="Clear all filters" onClick={resetFilters}>
            <span className="cmp-filterbar__button-text">Clear all filters</span>
          </button>
        </div>
      )}
    </div>
  )
}
